export const METAMASK = "MetaMask";
export const CRYPTO_WALLET_TYPE = "CRYPTO_WALLET";
